import AppStorage from './appStorage';

class RequestsStorage extends AppStorage {
  getStorageKey() {
    return this.appConfiguration.storageKeys.requests;
  }
}

export default RequestsStorage;
